"use strict";

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _typeof = require("/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeHttp = void 0;

function removeHttp(src) {
  if (!src) return src;
  var newSrc = src;

  if (_typeof(newSrc) === 'object' && newSrc.backgroundImage) {
    newSrc.backgroundImage = newSrc.backgroundImage.replace('p.qpic.cn', 'puep.qpic.cn');
    newSrc.backgroundImage = newSrc.backgroundImage.replace(/^http(s?):/, '');
    return newSrc;
  }

  if (typeof newSrc === 'string') {
    newSrc = newSrc.replace('p.qpic.cn', 'puep.qpic.cn');
    return newSrc.replace(/^http(s?):/, '');
  }

  return src;
}

exports.removeHttp = removeHttp;
exports.default = {
  removeHttp: removeHttp
};